<template>
  <v-row>
    <v-col cols="12">
      <OrdiniAttivi />
    </v-col>
    <v-col cols="12">
      <OrdiniEvasi/>
    </v-col>
  </v-row>
</template>

<script>
import OrdiniAttivi from "./ordini_attivi_desktop.vue";
import OrdiniEvasi from "../desktop/ordini_evasi_desktop.vue"
export default {
  components: {
    OrdiniAttivi,
    OrdiniEvasi
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 2px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
::-webkit-scrollbar-thumb {
  background: #bbbbbb;
}
.scroll {
  height: 300px;
  overflow-y: scroll;
}
</style>